import { useState, useEffect } from "react";
import MOBILE_SLIDER from "./common/Mobile_Slider";
import DESKTOP_VERTICAL_SLIDER from "./common/Desktop_VerticalSlider";
import DESKTOP_IMAGE_ZOOM from "./common/Desktop_Image_Zoom";
import HeartSvg from "./common/HeartSvg";
import { Link, useNavigate } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import Review from "./common/Review";
import { selectedProductById, fetchProductByProductIdAsync } from "../ProductList/ProductList_Slice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loggedInUser } from "../Auth/Auth_Slice";
import { addCartItemsAsync, updateCartItemsByUserIdAsync, isLoadingCart } from "../Cart/Cart_Slice";
import toast from 'react-hot-toast';
import { addItemInUserWishlistAsync, removeItemFromUserWishlistAsync, userWishlist } from "../User/userSlice";

const ratings = {
    "overall": "4.2",
    "totalRatings": 234981,
    "totalReviews": 24124,
    "counts": [
        { "ratings": 5, "count": 137909 },
        { "ratings": 4, "count": 57054 },
        { "ratings": 3, "count": 16007 },
        { "ratings": 2, "count": 5958 },
        { "ratings": 1, "count": 18053 }
    ]
}

const reviews = [
    {
        postedBy: "Lokesh Sain",
        rating: 5,
        title: "Awesome",
        description: "This is the one of the one best earbuds in any earbuds and sound quality and bass is very good 👍 This earbuds better than noice and boat earbuds really trust me one of the one best earbuds!! Thank-you Flipkart and oppo🤗🤗👏🤗"
    },
    {
        postedBy: "Suman Aggarwal",
        rating: 3,
        title: "Does the job",
        description: "One of the best tws I have ever bought, I personally like the clear vocals feature ,must buy this sound quality is awesome"
    },
    {
        postedBy: "Rohan Kumar Parida",
        rating: 4,
        title: "Good quality product",
        description: "Osm product 😍😍"
    }
]

const formatNumber = (number) => {
    if (number) {
        let x = number;
        x = x.toString();
        let lastThree = x.substring(x.length - 3);
        let otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '')
            lastThree = ',' + lastThree;
        let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return res;
    }
}



function ProductView_Compo() {
    const product = useSelector(selectedProductById);
    const wishlist = useSelector(userWishlist);
    const isLoading = useSelector(isLoadingCart);
    const status = useSelector((state) => state.product.status);

    const initialMainImage = product?.images?.[0] || null;

    //States which display the full image
    const [mainImage, setMainImage] = useState(initialMainImage);
    const [wishlistStatus, setWishlistStatus] = useState(false);
    const [productColor, setProductColor] = useState(null);
    const [productSize, setProductSize] = useState(); //if size is applicable
    const [showFullDescription, setShowFullDescription] = useState(false);

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(loggedInUser);
    const cartItems = useSelector(state => state.cart.items);

    //Navigation
    const productCategoryNavigation = product ? [
        {
            slugName: "Home",
            url: "/"
        },
        ...(product.category?.value ? [{
            slugName: product.category.value.replace(/-/g, ' '),
            url: `/?category=${product.category.value}`
        }] : []),

        // Sub-category add kar rahe hain (agar available hai)
        ...(product.subCategory?.value ? [{
            slugName: product.subCategory.value.replace(/-/g, ' '),
            url: `/?category=${product.category.value}&subCategory=${product.subCategory.value}`
        }] : []),

        // Last mein Exact Product Name
        {
            slugName: product.name,
            // Current product page ka link (ya aap ise '#' bhi chhod sakte hain)
            url: `/${product.href}/${product.id}`
        }
    ] : [];

    const handleSaveToWishlist = () => {
        if (user && user?.isAuthenticated && product) {
            dispatch(addItemInUserWishlistAsync(product.id)).then((response) => {
                if (response.payload.status === 'success') {
                    setWishlistStatus(true);
                    toast.success("Added to your Wishlist.", { id: "success" })
                } else {
                    toast.error(response.payload.message, { id: "error" })
                }
            });
        } else {
            navigate("/login")
        }
    }

    const handleRemoveFromWishlist = () => {
        if (user && user?.isAuthenticated && product) {
            dispatch(removeItemFromUserWishlistAsync(product.id)).then((response) => {
                if (response.payload.status === 'success') {
                    setWishlistStatus(false);
                    toast.success("Product removed from Wishlist.", { id: "success" })
                } else {
                    toast.error(response.payload.message, { id: "error" })
                }
            });
        } else {
            navigate("/login")
        }
    }

    const handleFeaturesReadMore = () => {
        document.getElementById("specSection").classList.add("activeFullView")
        document.getElementById("featureReadMore").remove();
    };

    useEffect(() => {
        dispatch(fetchProductByProductIdAsync(params.pid)).then(() => {
            //Check product is in user wishlist or not
            const wishlistProduct = wishlist.find(item => item.productId === params.pid);
            if (wishlistProduct) {
                setWishlistStatus(true)
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params, wishlist]);

    useEffect(() => {
        if (product) {
            // Main image set karo
            const initialMainImage = product?.images?.[0] || null;
            setMainImage(initialMainImage);
            //Agar item already cart mein hai, toh uska Color & Size pre-select kar do
            if (cartItems && cartItems.length > 0) {
                const existingItem = cartItems.find(item => item?.productId === product?.id);
                if (existingItem) {
                    if (existingItem.color) setProductColor(existingItem.color);
                    if (existingItem.size) setProductSize(existingItem.size);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product?.id, cartItems?.length]);

    // Check if the product is already in the cart
    const existingCartItem = cartItems !== null ? cartItems.find(item => item?.productId === product?.id) : null;

    // Check if ki kya EXACT selected color aur size cart mein hai
    const isExactVariantInCart = existingCartItem &&
        (productColor ? existingCartItem.color === productColor : true) &&
        (productSize ? existingCartItem.size === productSize : true);

    // Check if product has a size option, and if selected
    const hasSizeOption = product?.size?.length > 0;

    const handleAddToCart = async () => {
        if (user && user?.isAuthenticated) {
            if (productColor && (!hasSizeOption || (hasSizeOption && productSize))) {
                // AGAR ITEM CART MEIN HAI PAR COLOR ALAG HAI TO UPDATE KARO
                if (existingCartItem && !isExactVariantInCart) {
                    await dispatch(updateCartItemsByUserIdAsync({
                        id: existingCartItem.id, //cart id
                        color: productColor,     // New color
                        size: hasSizeOption ? productSize : null
                    }));
                    toast.success("Cart updated with new variant.", { id: "success" });
                    return true;
                }
                // AGAR NAYA ITEM HAI TO ADD KARO
                else {
                    const productAddToCart = { productId: product.id, quantity: 1 };
                    await dispatch(addCartItemsAsync({ ...productAddToCart, color: productColor, size: hasSizeOption ? productSize : null }));
                    toast.success("Added to cart.", { id: "success" });
                    return true;
                }
            } else {
                const errorMessage = !productColor ? 'Please choose a color.' : hasSizeOption && !productSize ? 'Please choose a size.' : 'Something went wrong.';
                toast.error(errorMessage, { id: "warning" });
                return false;
            }
        } else {
            navigate("/login");
            return false;
        }
    }

    const handleAddToCartAndCheckout = async () => {
        if (user && user?.isAuthenticated) {
            if (isExactVariantInCart) {
                navigate("/checkout?view=uptrend&loginFlow=false");
            } else {
                const isSuccess = await handleAddToCart();
                if (isSuccess) {
                    navigate("/checkout?view=uptrend&loginFlow=false");
                }
            }
        } else {
            navigate("/login");
        }
    }

    const handleRedirectToCart = () => {
        navigate("/cart")
    }


    const handleCheckoutDirect = () => {
        navigate("/checkout?view=uptrend&loginFlow=false")
    }

    if (status === 'loading' || !product) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[70vh] bg-white">
                <div className="relative w-16 h-16">
                    <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-100 rounded-full"></div>
                    <div className="absolute top-0 left-0 w-full h-full border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
                </div>
                <p className="mt-4 text-gray-500 font-medium animate-pulse">Loading product details...</p>
            </div>
        );
    }

    return (
        <section className="bg-white">
            <div className="max-w-2xl mx-auto px-0 pt-6 sm:px-6 lg:max-w-full lg:px-4">
                <div className="lg:grid lg:grid-cols-5 lg:items-start lg:gap-6">
                    <div className="flex z-30 justify-center items-center col-span-2 p-0 md:p-2 lg:sticky lg:top-24 bg-white">
                        <div className="mx-auto w-full lg:max-w-none">
                            {/* for Mobile, tablet Carousel */}
                            {mainImage &&
                                <>
                                    <div className="block lg:hidden mx-auto w-full  my-0 lg:my-0 lg:max-w-full relative ">
                                        {product.images && product.images.length > 1 ?
                                            <MOBILE_SLIDER imgArray={product.images} />
                                            :
                                            <img src="/no-image-available.png" className="object-contain h-full w-full object-center" alt="alternate" />
                                        }
                                        <div className="absolute flex items-center justify-center wishlist bottom-20 right-[1em]  w-9 h-9 z-30 rounded-full bg-white cursor-pointer">
                                            <HeartSvg checked={wishlistStatus} handleWishlist={handleSaveToWishlist} handleRemove={handleRemoveFromWishlist} />
                                        </div>
                                    </div>

                                    {/* For Desktop */}
                                    <div className="hidden lg:flex basis-full py-3 border-[1px] border-gray-100 box-border">
                                        {product.images && product.images.length > 1 ?
                                            <>
                                                <div className="basis-1/6 px-3 border-r-[1px] border-gray-100 grid h-2">
                                                    <DESKTOP_VERTICAL_SLIDER imgArray={product.images} setMainImage={setMainImage} mainImage={mainImage} />
                                                </div>
                                                <div className="lg:basis-5/6 px-3 relative">
                                                    <div className="mainImageContainer aspect-[1/1] border-[1px] border-gray-200 mycustomshadow1 p-4">
                                                        <DESKTOP_IMAGE_ZOOM mainImage={mainImage} />
                                                    </div>
                                                    <div className="absolute flex items-center justify-center wishlist top-3 right-6  w-9 h-9 rounded-full bg-white cursor-pointer shadow-sm border border-gray-100">
                                                        <HeartSvg checked={wishlistStatus} handleWishlist={handleSaveToWishlist} handleRemove={handleRemoveFromWishlist} />
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <img src="/no-image-available.png" className="object-contain object-center w-full aspect-square" alt="alternate" />
                                        }
                                    </div>
                                </>
                            }
                            {/* Display only on desktop devices because in mobile i want sticky */}
                            <div className="hidden lg:flex py-4">
                                <div className="basis-1/6"></div>
                                <div className="flex basis-5/6 justify-evenly">
                                    <button onClick={isExactVariantInCart ? handleRedirectToCart : handleAddToCart} type="button" className="w-44 addtoCart px-2 py-3 text-base font-medium inline-flex items-center justify-center text-white bg-indigo-600 rounded-md border-[2px] border-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 uppercase">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 text-white mr-1" style={{ "paddingBottom": "2px" }}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                                        </svg>
                                        {isLoading ? "Processing..." : isExactVariantInCart ? "Go To Cart" : existingCartItem ? "Update Cart" : "Add To Cart"}
                                    </button>
                                    <button onClick={isExactVariantInCart ? handleCheckoutDirect : handleAddToCartAndCheckout} type="button" className="w-44  buynowBtn px-2 py-3 text-base font-medium inline-flex items-center justify-center group text-indigo-600 bg-gray-100 rounded-md border-[2px] border-indigo-600 hover:bg-indigo-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-indigo-300 focus:bg-indigo-700 focus:text-white uppercase">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 mr-1 text-indigo-600 group-hover:text-white group-focus:text-white">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                                        </svg>
                                        {isLoading ? "Redirecting..." : "Buy Now"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* part 2 */}
                    <div className="px-4 sm:px-1 col-span-3 bg-white">
                        <div className="hidden w-full lg:flex flex-nowrap align-middle justify-between mt-2">
                            <div className="breadcrumbs basis-11/12">
                                <nav aria-label="Breadcrumb">
                                    <ol className="slugNavigation flex items-center space-x-2">
                                        {productCategoryNavigation.map((slug, index) => (
                                            <li key={slug.slugName + index} className="flex items-center">
                                                <Link to="#" className="inline-flex items-baseline justify-between text-xs text-gray-500 hover:text-indigo-600 transition-colors">
                                                    <span className="max-w-[150px] text-ellipsis whitespace-nowrap capitalize overflow-hidden">{slug.slugName}</span>
                                                </Link>
                                                {index !== productCategoryNavigation.length - 1 && (
                                                    <svg className="w-[5px] h-2.5 text-gray-400 mx-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10"> <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" /> </svg>
                                                )}
                                            </li>
                                        ))}
                                    </ol>
                                </nav>
                            </div>
                            <div className="inline-block basis-1/12">
                                <div className="w-full">
                                    <div className="flex items-center justify-end group text-gray-500 font-medium cursor-pointer hover:text-indigo-600 transition-colors">
                                        <svg className="w-5 fill-gray-500 group-hover:fill-indigo-600 transition-colors" fill="none" viewBox="-4 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>forward</title> <path d="M15.438 6.344v3.875c-16.563 0-15.406 15.438-15.406 15.438 3.25-10.781 15.406-7.656 15.406-7.656v3.969l8.563-7.938z"></path> </g></svg>
                                        <h3 className="text-sm ml-1">Share</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="product-details">
                            <div className="productName py-2 mt-4 lg:mt-2">
                                <h1 className="text-xl lg:text-2xl font-semibold text-gray-900 tracking-tight">{product.name}</h1>
                            </div>

                            <div className="productRating py-1 flex justify-start">
                                {ratings.overall ? <HashLink smooth to="#ratingReviewSection"> <div className="flex items-center hover:opacity-80 transition-opacity cursor-pointer">
                                    <div className={`ratingbox ${(ratings.overall <= 1) ? "bgLowRating" : (ratings.overall < 4) ? "bgAverageRating" : "bgPositiveRating"}    inline-flex items-center font-medium text-white px-2 py-0.5 rounded text-sm`}>
                                        {ratings.overall}
                                        <img className="ml-1" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMiI+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTYuNSA5LjQzOWwtMy42NzQgMi4yMy45NC00LjI2LTMuMjEtMi44ODMgNC4yNTQtLjQwNEw2LjUuMTEybDEuNjkgNC4wMSA0LjI1NC40MDQtMy4yMSAyLjg4Mi45NCA0LjI2eiIvPjwvc3ZnPg==" alt="Starlogo" style={{ height: "12px" }}></img>
                                    </div>
                                    <div className="px-3 text-gray-500 font-medium text-sm" >
                                        <span>{formatNumber(ratings.totalRatings)} Ratings</span> &
                                        <span> {formatNumber(ratings.totalReviews)} Reviews</span>
                                    </div>
                                </div>
                                </HashLink> :
                                    <Link to="#"><h2 className="text-indigo-600 font-semibold text-sm hover:underline">Be the first to Review this product</h2></Link>
                                }
                            </div>

                            <div className="priceSection py-4 border-b border-gray-100">
                                <h3 className="font-medium text-sm positive-green-color mb-1">Special Price</h3>
                                <div className="flex items-end gap-3">
                                    <h2 className="font-bold text-gray-900 text-3xl">₹{formatNumber(product.price)}</h2>
                                    <h3 className="font-medium text-gray-500 line-through text-lg mb-0.5">₹{formatNumber(product.originalPrice)}</h3>
                                    <h4 className='font-bold positive-green-color text-base mb-0.5'>{100 - (Math.round((product.price / product.originalPrice) * 100))}% Off</h4>
                                </div>
                            </div>

                            <div className="productDetails py-4 space-y-6 border-b border-gray-100">
                                {product.color && product.color.length > 0 &&
                                    <div className="colorSection lg:flex items-start">
                                        <div className="w-24 shrink-0 mb-2 lg:mb-0">
                                            <h2 className="font-semibold text-gray-500 text-sm mt-1">Color</h2>
                                        </div>
                                        <div className="flex flex-wrap gap-2">
                                            {product.color.map((color, index) => (
                                                <button
                                                    key={color + index}
                                                    className={`${productColor === color ? "border-indigo-600 bg-indigo-50 text-indigo-700" : "border-gray-200 text-gray-700 hover:border-gray-300"} border-2 rounded-md px-4 py-1.5 text-sm font-medium transition-all flex items-center outline-none`}
                                                    onClick={() => setProductColor(color)}
                                                >
                                                    {color}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                }

                                {product.size && product.size.length > 0 &&
                                    <div className="sizeSection lg:flex items-start">
                                        <div className="w-24 shrink-0 mb-2 lg:mb-0">
                                            <h2 className="font-semibold text-gray-500 text-sm mt-1">Size</h2>
                                        </div>
                                        <div className="flex flex-wrap gap-2">
                                            {product.size.map((siz, index) => (
                                                <button
                                                    key={siz + index}
                                                    className={`${productSize === siz ? "border-indigo-600 bg-indigo-50 text-indigo-700" : "border-gray-200 text-gray-700 hover:border-gray-300"} border-2 rounded-md px-4 py-1.5 text-sm font-medium transition-all outline-none`}
                                                    onClick={() => setProductSize(siz)}
                                                >
                                                    {siz}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                }

                                {product.highlights && product.highlights.length > 0 &&
                                    <div className="highlight-section lg:flex items-start">
                                        <div className="w-24 shrink-0 mb-2 lg:mb-0">
                                            <h2 className="font-semibold text-gray-500 text-sm mt-1">Highlights</h2>
                                        </div>
                                        <div className="text-sm">
                                            <ul className="list-disc pl-5 space-y-1.5 text-gray-700">
                                                {product.highlights.map((highlight, index) => (
                                                    <li key={highlight + index} className="capitalize">{highlight}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                }

                                {product.description &&
                                    <div className="description lg:flex items-start">
                                        <div className="w-24 shrink-0 mb-2 lg:mb-0">
                                            <h2 className="font-semibold text-gray-500 text-sm mt-1">Description</h2>
                                        </div>
                                        <div className="flex-1">
                                            <div className={`text-sm text-gray-700 leading-relaxed ${!showFullDescription ? "line-clamp-4" : ""}`}>
                                                {product.description}
                                            </div>
                                            {product.description.length > 250 &&
                                                <button
                                                    type="button"
                                                    onClick={() => setShowFullDescription(!showFullDescription)}
                                                    className="text-sm text-indigo-600 font-semibold mt-2 hover:underline focus:outline-none"
                                                >
                                                    {showFullDescription ? "Read Less" : "Read More"}
                                                </button>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>

                            {product.specifications && product.specifications.length > 0 &&
                                <div className="specifications py-6 border-b border-gray-100">
                                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Specifications</h2>
                                    {/* Spec Container */}
                                    <div className="specSection overflow-hidden border border-gray-200 rounded-lg relative" id="specSection">
                                        {product.specifications.map((feature, index) => (
                                            <div key={feature.heading + index} className="border-b border-gray-200 last:border-b-0">
                                                <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                                                    <h3 className="font-semibold text-gray-800 text-sm uppercase tracking-wider">{feature.heading}</h3>
                                                </div>
                                                <div className="px-4 py-3">
                                                    <table className="w-full text-sm">
                                                        <tbody className="divide-y divide-gray-100">
                                                            {feature.data.map((specs, idx) => (
                                                                <tr key={specs.key + idx} className="flex py-3">
                                                                    <td className="w-1/3 pr-4 font-medium text-gray-500">{specs.key}</td>
                                                                    <td className="w-2/3 text-gray-900">{specs.value}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="w-full mt-3 text-center" id="featureReadMore">
                                        <button
                                            type="button"
                                            className="text-sm text-indigo-600 hover:text-indigo-800 font-semibold py-2 px-4 transition-colors focus:outline-none"
                                            onClick={handleFeaturesReadMore}>
                                            Read More ↓
                                        </button>
                                    </div>
                                </div>
                            }

                            <div className="ratingReviews py-6 border-t border-gray-100" id="ratingReviewSection">
                                <div className="flex items-center justify-between mb-6">
                                    <h2 className="text-xl font-semibold text-gray-900">Ratings & Reviews</h2>
                                    <Link to="#">
                                        <button type="button" className="text-gray-900 bg-white hover:bg-gray-50 text-sm font-semibold px-4 py-2 rounded-lg border border-gray-300 shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                            Rate Product
                                        </button>
                                    </Link>
                                </div>

                                {ratings ?
                                    <div className="reviewRatingsWrapper">
                                        <div className="flex items-center mb-6">
                                            <div className="flex items-center gap-2">
                                                <p className="text-3xl font-bold text-gray-900">{ratings.overall}</p>
                                                <svg className="w-6 h-6 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                                    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <p className="text-sm font-medium text-gray-500 ml-4 border-l border-gray-300 pl-4">
                                                {formatNumber(ratings.totalRatings)} Ratings &<br />{formatNumber(ratings.totalReviews)} Reviews
                                            </p>
                                        </div>

                                        <div className="reviewRatingContainer max-w-sm mb-8 space-y-2">
                                            {ratings.counts && ratings.counts.map((rating) => (
                                                <div key={rating.count} className="flex items-center">
                                                    <div className="flex items-center w-8 shrink-0 text-sm font-medium text-gray-600">
                                                        {rating.ratings} <span className="ml-1 text-xs">★</span>
                                                    </div>
                                                    <div className="w-full h-2 mx-3 bg-gray-100 rounded-full overflow-hidden">
                                                        <div
                                                            className={`h-full ${(rating.ratings <= 1) ? "bg-red-500" : (rating.ratings < 4) ? "bg-amber-400" : "bg-green-500"}`}
                                                            style={{ "width": ((rating.count / ratings.totalRatings) * 100) + "%" }}
                                                        ></div>
                                                    </div>
                                                    <div className="w-10 text-right shrink-0 text-xs font-medium text-gray-500">
                                                        {((rating.count / ratings.totalRatings) * 100).toFixed(0)}%
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {reviews &&
                                            <div className="reviewContainer space-y-6">
                                                {reviews.map((review, index) => (
                                                    <div key={review.title + index} className={index !== reviews.length - 1 ? "border-b border-gray-100 pb-6" : ""}>
                                                        <Review review={review} />
                                                    </div>
                                                ))}
                                                <div className="pt-4">
                                                    <Link to="#" className="text-sm font-semibold text-indigo-600 hover:text-indigo-700 hover:underline">
                                                        Read All {formatNumber(ratings.totalReviews)} Reviews &rarr;
                                                    </Link>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    :
                                    <div className="bg-gray-50 rounded-lg p-6 text-center">
                                        <h2 className="text-gray-600 font-medium">There are no customer reviews for this product yet!</h2>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* Fixed Mobile Bottom Bar (Add to Cart / Buy Now) */}
                <div className="sticky bg-white bottom-0 w-full rounded-t-xl shadow-[0_-4px_10px_-2px_rgba(0,0,0,0.05)] mobileStickyBottom z-30" id="buyNow">
                    <div className="flex lg:hidden py-3 gap-3 px-4 justify-between items-center w-full">
                        <button
                            onClick={isExactVariantInCart ? handleRedirectToCart : handleAddToCart}
                            type="button"
                            className="flex-1 whitespace-nowrap addtoCart px-2 py-3 text-[13px] sm:text-sm font-semibold inline-flex items-center justify-center text-white bg-indigo-600 rounded-lg border-2 border-indigo-600 hover:bg-indigo-700 transition-colors uppercase tracking-wide shadow-sm"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-4 h-4 sm:w-5 sm:h-5 text-white mr-1.5 pb-[1px]">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                            </svg>
                            {isLoading ? "Processing..." : isExactVariantInCart ? "Go To Cart" : existingCartItem ? "Update Cart" : "Add To Cart"}
                        </button>

                        <button
                            onClick={isExactVariantInCart ? handleCheckoutDirect : handleAddToCartAndCheckout}
                            type="button"
                            className="flex-1 whitespace-nowrap buynowBtn px-2 py-3 text-[13px] sm:text-sm font-semibold inline-flex items-center justify-center group text-indigo-600 bg-white rounded-lg border-2 border-indigo-600 hover:bg-indigo-700 hover:text-white transition-colors uppercase tracking-wide shadow-sm"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 text-indigo-600 group-hover:text-white pb-[1px] transition-colors">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                            </svg>
                            {isLoading ? "Redirecting..." : "Buy Now"}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ProductView_Compo;